export default {
  high: 'high',
  standard: 'standard',
  low: 'low',
};
